module.exports = __webpack_public_path__ + "static/media/silva.b8bc2075.png";